export const AUTH_FAILURE_REASON_MESSAGES = {
  auth_failed: "Sign-in failed before a session could be created.",
  provider_callback_failed:
    "Google returned an auth callback error before the session exchange completed.",
  exchange_failed:
    "Google sign-in returned, but Supabase could not finish the session exchange.",
  missing_access_token:
    "Sign-in returned without an access token, so the session could not be completed.",
  backend_sync_failed:
    "Sign-in succeeded, but backend sync failed.",
}

export function getProviderCallbackErrorDetails(searchParams) {
  const error = searchParams.get("error")
  const errorCode = searchParams.get("error_code")
  const errorDescription = searchParams.get("error_description")

  if (!error && !errorCode && !errorDescription) {
    return null
  }

  return {
    error,
    errorCode,
    errorDescription,
  }
}

export function buildAuthFailureRedirectUrl({ origin, error, reason }) {
  const url = new URL("/", origin)
  url.searchParams.set("error", error)
  if (reason) {
    url.searchParams.set("reason", reason)
  }
  return url.toString()
}

export function getAuthFailureMessage({ error, reason }) {
  if (!error) return null

  if (reason && AUTH_FAILURE_REASON_MESSAGES[reason]) {
    return AUTH_FAILURE_REASON_MESSAGES[reason]
  }

  if (AUTH_FAILURE_REASON_MESSAGES[error]) {
    return AUTH_FAILURE_REASON_MESSAGES[error]
  }

  return "Sign-in failed. Please try again."
}
